import { useId } from 'react';
import type { CourseStandard } from '../../core/course';
import type { PlanUnit } from '../../core/types';
import { MoveMenu } from './MoveMenu';
import { moveTargets, plural, StandardItem, type EditRequest } from './UnitRow';

/** Standards in no unit yet, always visible so nothing is lost (R6). */
export function NotYetPlaced({ standards, units, onEdit }: { standards: CourseStandard[]; units: PlanUnit[]; onEdit(edit: EditRequest): void }) {
  const titleId = useId();
  return <section className="standards-bin" aria-labelledby={titleId}>
    <h2 id={titleId}>Not yet placed</h2>
    <p className="muted">{standards.length ? `${plural(standards.length, 'standard')} in no unit yet.` : 'Every standard has a place.'}</p>
    {standards.length > 0 && <ul className="plan-standards">{standards.map(s => <StandardItem key={s.id} standard={s}>
      <MoveMenu label={`Move ${s.code || s.statement} to`} targets={moveTargets(s.id, 'not_yet_placed', units, onEdit)} />
    </StandardItem>)}</ul>}
  </section>;
}

/** Standards the teacher set aside, collapsed, each with Restore (R6, R10). */
export function NotInCourse({ standards, onEdit }: { standards: CourseStandard[]; onEdit(edit: EditRequest): void }) {
  if (!standards.length) return null;
  return <details className="standards-bin excluded">
    <summary>Not in my course ({standards.length})</summary>
    <ul className="plan-standards">{standards.map(s => <StandardItem key={s.id} standard={s}>
      <button type="button" className="text-button" aria-label={`Restore ${s.code || s.statement}`} onClick={() => onEdit({ type: 'restore_standard', standardId: s.id })}>Restore</button>
    </StandardItem>)}</ul>
  </details>;
}
